import moment from 'moment';

export let createEngineerDayQueryString = (engineerId, date) => "?engineerId=" + engineerId + "&&" + createDateQueryStringParam(date);
export let createEngineerJobQueryString = (engineerId, jobId) => "?engineerId=" + engineerId + "&&jobId=" + jobId;
export let createDateQueryStringParam = (date) => "date=" + date.toUTCString();

export let crudRequestOptions = (method, body) => {
    return { 
        method: method,
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify(body),
    };
};

Date.prototype.toJSON = function(){ return moment(this).format(); }